import React from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "./assets/css/style.css";
import "./assets/css/Media.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

import CombineRoutes from "./routes/CombineRoutes";
import FullScreenLoader from "./components/Loader/FullScreenLoader";
import NativeAuthSync from "./components/NativeAuthSync";
import MessageProvider from "./components/MessageProvider";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./redux/store";
import { appRootTheme } from "./theme/ftcTheme";

function App() {
    return (
        <ThemeProvider theme={appRootTheme}>
            <CssBaseline />
            <Provider store={store}>
                <PersistGate loading={<FullScreenLoader />} persistor={persistor}>
                    <MessageProvider>
                        <div className="App">
                            <NativeAuthSync />
                            <CombineRoutes />
                        </div>
                    </MessageProvider>
                </PersistGate>
            </Provider>
            <ToastContainer
                position="top-right"
                autoClose={4000}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </ThemeProvider>
    );
}

export default App;
